module.exports = __webpack_public_path__ + "img/resident-payment-history-empty.caa1ead2.png";